<template>
<div>

  <panel>
      <p slot="header">
          {{ item.name }} <span class="gray">(konto do wysyłania)</span>
      </p>
      <p slot="actions">
          <ui-button type="flat" icon="navigate_before" color="primary" @click="$router.push({name: 'admin.accounts.dashboard'})">Wróć</ui-button>
          <ui-button type="flat" icon="mode_edit" color="primary" @click="test">Testuj konto</ui-button>
          <ui-button type="flat" icon="mode_edit" color="primary" @click="edit">Edytuj konto</ui-button>
      </p>
      <table class="table info-table">
          <tr>
              <th class="fifty">
                  Nazwa wysyłającego wiadomości
              </th>
              <td>
                  {{ item.from_name }}
              </td>
          </tr>
          <tr>
              <th>
                  Adres e-mail z jakiego będą wychodzić wiadomości
              </th>
              <td>
                  {{ item.from_address }}
              </td>
          </tr>

      </table>
  </panel>
  <panel>
      <p slot="header">
          Konto smtp
      </p>

      <table class="table info-table">
          <tr>
              <th class="fifty">
                  Host
              </th>
              <td>
                  {{ item.host }}
              </td>
          </tr>
          <tr>
              <th>
                  Port
              </th>
              <td>
                  {{ item.port }}
              </td>
          </tr>
          <tr>
              <th>
                  Host
              </th>
              <td>
                  {{ item.host }}
              </td>
          </tr>
          <tr>
              <th>
                  Nazwa użytkownika
              </th>
              <td>
                  {{ item.username }}
              </td>
          </tr>
          <tr>
              <th>
                  Hasło
              </th>
              <td>
                  <ui-button style="float: right;" @click.prevent="showPassword = !showPassword">pokaż / zakryj</ui-button>
                  <span v-if="showPassword">{{ item.password }}</span>
                  <span v-if="!showPassword">****</span>

              </td>
          </tr>
      </table>
  </panel>
  <panel>
      <p slot="header">
          Limit wysyłania
      </p>
      <table class="table info-table">
          <tr>
              <th class="fifty">
                  Limit wysyłanych wiadomości za jednym razem
              </th>
              <td>
                  {{ item.limit }}
              </td>
          </tr>
      </table>
  </panel>

</div>
</template>

<script>
import Accounts from './../../services/Accounts'
import Loading from './../../mixins/Loading'
import Notify from './../../mixins/Notify'

export default {
  mixins: [Loading, Notify],
  data () {
    return {
      showPassword: false,
      item: Accounts.getBaseItem(),
      id: null
    }
  },
  mounted () {
    this.id = this.$route.params.id
    this.getItem(this.id)
  },
  methods: {
    edit () {
      this.$router.push({name: 'admin.accounts.edit', params: {id: this.id}})
    },
    test () {
      this.$router.push({name: 'admin.accounts.test', params: {id: this.id}})
    },
    getItem (id) {
      this.setLoading(true)
      Accounts.get(id).then((res) => {
        this.item = res.data.item
        this.setLoading(false)
      })
    }
  }
}

</script>


// WEBPACK FOOTER //
// Show.vue?6600a954